<div class="container" #scroolEl (scroll)="scrolling($event)">
  <div class="cooking-story-header" [ngClass]="{ shadow: shadowNav }">
    <div>
      <img
        src="assets/cookingbook/more_blue.svg"
        class="more"
        (click)="showBottomSheet()"
        *ngIf="!shadowNav"
        alt=""
      />
      <img
        src="assets/cookingbook/more.svg"
        class="more"
        *ngIf="shadowNav"
        (click)="showBottomSheet()"
        alt=""
      />
    </div>
    <div *ngIf="shadowNav" class="recipe-title">
      <p class="recipe-name">{{ recipe.food.name }}</p>
      <img
        src="assets/cookingbook/like.svg"
        *ngIf="!liked && !isReady"
        (click)="Bookmarking()"
        alt=""
      />
      <img
        src="assets/cookingbook/liked.svg"
        *ngIf="liked && !isReady"
        (click)="Bookmarking()"
        alt=""
      />
    </div>
    <div>
      <img
        src="assets/cookingbook/angle_blue.svg"
        class="back"
        *ngIf="!shadowNav"
        (click)="goBack()"
        alt=""
      />
      <img
        src="assets/cookingbook/angle-white.svg"
        class="back icon-shadow"
        *ngIf="shadowNav"
        (click)="goBack()"
        alt=""
      />
    </div>
  </div>
  <div
    *ngIf="isReady"
    class="cooking-story-image recipe-shadow"
    [ngStyle]="{
      'background-image': 'url(' + recipe?.imagePath + ')',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      opacity: alfa
    }"
  >
    <div class="play-icon" (click)="showvideo()" *ngIf="recipe?.video">
      <span> تماشای ویدیو </span>
      <img src="assets/cookingbook/play-small.svg" alt="" />
    </div>
  </div>
  <div *ngIf="!isReady" class="cooking-story-image">
    <ngx-skeleton-loader
      animation="pulse"
      [theme]="{
        margin: 'auto',
        height: '250px',
        background: 'rgb(216, 216, 216)'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div class="cooking-story-body">
    <div>
      <ngx-skeleton-loader
        *ngIf="!isReady"
        animation="pulse"
        [theme]="{
          width: '68px',
          height: '20px',
          background: 'rgb(216, 216, 216)'
        }"
      ></ngx-skeleton-loader>
      <span class="label" *ngIf="isReady"> {{ categorie?.name }} </span>
    </div>
    <div class="recipe-food-name">
      <p class="recipe-name">
        <ngx-skeleton-loader
          *ngIf="!isReady"
          animation="pulse"
          [theme]="{
            width: '100px',
            height: '20px',
            background: 'rgb(216, 216, 216)'
          }"
        ></ngx-skeleton-loader>
        <span *ngIf="isReady">
          {{ recipe?.food.name }}
        </span>
      </p>
      <img
        src="assets/cookingbook/like.svg"
        *ngIf="!liked"
        (click)="Bookmarking()"
        alt=""
      />
      <img
        src="assets/cookingbook/liked.svg"
        *ngIf="liked"
        (click)="Bookmarking()"
        alt=""
      />
    </div>
    <div class="helpbar">
      <div style="text-align: center">
        <img src="assets/cookingbook/like-gray.svg" alt="" />
        <ngx-skeleton-loader
          *ngIf="!isReady"
          animation="pulse"
          [theme]="{
            width: '40px',
            height: '20px',
            display: 'block',

            background: 'rgb(216, 216, 216)'
          }"
        ></ngx-skeleton-loader>
        <p *ngIf="isReady">
          {{ recipe?.likes }}
        </p>
      </div>
      <div style="text-align: center">
        <img src="assets/cookingbook/time-gray.svg" alt="" />
        <ngx-skeleton-loader
          *ngIf="!isReady"
          animation="pulse"
          [theme]="{
            width: '40px',
            height: '20px',
            display: 'block',
            background: 'rgb(216, 216, 216)'
          }"
        ></ngx-skeleton-loader>
        <p *ngIf="isReady">
          {{ recipe?.time }}
        </p>
      </div>
      <div style="text-align: center">
        <img src="assets/cookingbook/fridge-gray.svg" alt="" />
        <ngx-skeleton-loader
          *ngIf="!isReady"
          animation="pulse"
          [theme]="{
            width: '40px',
            height: '20px',
            display: 'block',
            background: 'rgb(216, 216, 216)'
          }"
        ></ngx-skeleton-loader>
        <p *ngIf="isReady">% {{ fridge }}</p>
      </div>
    </div>
    <p class="description">
      {{ recipe?.description }}
    </p>
    <div class="serving">
      <p>تعداد پرس:</p>
      <div class="handler">
        <img
          src="assets/cookingbook/servingp.svg"
          (click)="increaseServing()"
          alt=""
        />
        <ngx-skeleton-loader
          *ngIf="!isReady"
          animation="pulse"
          [theme]="{
            width: '40px',
            height: '20px',
            margin: '0px',
            display: 'flex',
            'align-items': 'center',
            background: 'rgb(216, 216, 216)'
          }"
        ></ngx-skeleton-loader>
        <p *ngIf="isReady">{{ recipe?.serving }}</p>
        <img
          src="assets/cookingbook/servingm.svg"
          (click)="decreaseServing()"
          alt=""
        />
      </div>
    </div>

    <div *ngIf="!isReady" class="tabs">
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          width: '40px',
          height: '20px',
          margin: '0px',
          display: 'flex',
          'align-items': 'center',
          background: 'rgb(216, 216, 216)'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          width: '40px',
          height: '20px',
          margin: '0px',
          display: 'flex',
          'align-items': 'center',
          background: 'rgb(216, 216, 216)'
        }"
      ></ngx-skeleton-loader>
      <ngx-skeleton-loader
        animation="pulse"
        [theme]="{
          width: '40px',
          height: '20px',
          margin: '0px',
          display: 'flex',
          'align-items': 'center',
          background: 'rgb(216, 216, 216)'
        }"
      ></ngx-skeleton-loader>
    </div>
    <div class="tabs" *ngIf="isReady">
      <div id="firstTab" class="tab1" (click)="changeTab($event, 0)">
        مواد ‌لازم
      </div>
      <div class="tab2" (click)="changeTab($event, 1)">دستور‌پخت</div>
      <div class="tab3" (click)="changeTab($event, 2)">ارزش‌غذایی</div>
      <div id="hover">{{ activeTab }}</div>
    </div>
    <div *ngIf="!isReady">
      <div *ngFor="let ingredient of garr(6)" class="recipe-detail-ingredient">
        <div class="recipe-title">
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              width: '140px',
              height: '20px',
              margin: '0px',
              display: 'flex',
              'align-items': 'center',
              background: 'rgb(216, 216, 216)'
            }"
          ></ngx-skeleton-loader>
        </div>
        <div>
          <ngx-skeleton-loader
            animation="pulse"
            [theme]="{
              width: '140px',
              height: '20px',
              margin: '0px',
              display: 'flex',
              'align-items': 'center',
              background: 'rgb(216, 216, 216)'
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div *ngIf="isReady">
      <div class="" style="margin-bottom: 105px" *ngIf="activeTabNumber == 0">
        <div
          *ngFor="let ingredient of recipe?.ingredients"
          class="recipe-detail-ingredient"
        >
          <div class="recipe-title">
            {{ ingredient.food.name }}
          </div>
          <div *ngIf="ingredient.amount === 0">(به مقدار لازم)</div>
          <div *ngIf="ingredient.amount !== 0" class="recipe-description">
            {{ addZeroes(ingredient.amount.toString()) }}
            {{ ingredient.unit.name }}
            <img
              src="assets/cookingbook/fridge-blue.svg"
              *ngIf="ingredient.kitchenInventory"
              alt=""
            />
          </div>
        </div>
      </div>
      <div *ngIf="activeTabNumber == 1" class="recipe-detail-parent">
        <div
          *ngFor="let instruction of recipe.instructions; let i = index"
          class="recipe-detail-instruction"
        >
          <div class="recipe-detail-instruction-number">{{ i + 1 }}</div>
          <div class="recipe-detail-instruction-text">
            {{ instruction.text }}
          </div>
        </div>
      </div>
      <div *ngIf="activeTabNumber == 2">
        <div
          *ngFor="
            let foodFact of foodFactsNames;
            let i = index;
            let first = first
          "
        >
          <div
            *ngIf="first"
            class="food-fact-cell box food-fact-cell-change-unit"
          >
            <div class="food-fact-cell-title">میزان واحد</div>
            <div
              class="food-fact-cell-unit-holder"
              (click)="changeFoodAmountOrRatio()"
            >
              <div class="food-fact-cell-amount">در هر{{ unitTitle }}</div>
              <div class="food-fact-cell-unit">
                <img src="assets/plans/edit-blue.svg" alt="" />
              </div>
            </div>
          </div>
          <div *ngIf="foodFactsAmount[i] !== -1" class="food-fact-cell box">
            <div class="food-fact-cell-title">{{ foodFact }}</div>
            <div class="food-fact-cell-unit-holder">
              <div class="food-fact-cell-amount">
                {{ addZeroes(foodFactsAmount[i].toString()) }}
              </div>
              <div class="food-fact-cell-unit">{{ foodFactsUnits[i] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="recipe-detail active" *ngIf="activeTabNumber == 0">
    <div
      class="recipe-detail-button cart"
      *ngIf="isReady"
      (click)="openCartBottomSheet()"
    >
      <img src="assets/cookingbook/cart.svg" alt="" />
      <p>افزودن به سبد خرید</p>
    </div>
    <ngx-skeleton-loader
      animation="pulse"
      *ngIf="!isReady"
      [theme]="{
        width: '280px',
        height: '52px',
        margin: '0px',
        display: 'flex',
        'align-items': 'center',
        background: 'rgb(216, 216, 216)',
        'border-radius': '24px'
      }"
    ></ngx-skeleton-loader>
  </div>
  <div class="recipe-detail active" *ngIf="activeTabNumber == 1">
    <div class="recipe-detail-button" (click)="goToTutorial()">
      <img src="assets/cookingbook/forward.svg" alt="" />
      <p>شروع آشپزی</p>
    </div>
  </div>
</div>
<app-bottomsheet
  [type]="'recipe-more'"
  [data]="{ url: recipeId, share: url, title: recipe.food.name }"
  *ngIf="bottomSheetShow"
></app-bottomsheet>

<div class="video-player" *ngIf="recipe && recipe.video && showVideo">
  <div class="video-player--header">
    <img
      (click)="closevideo()"
      class="icon-shadow"
      src="assets/cookingbook/angle-white.svg"
      alt=""
    />
    <p>
      {{ recipe.food?.name }}
    </p>
  </div>
  <app-cooking-story-player
    [isTutorial]="false"
    [show]="true"
    [data]="{ src: recipe.video, start: 0, end: 0, holder: recipe.imagePath }"
  ></app-cooking-story-player>
</div>
<app-cooking-story-success-message></app-cooking-story-success-message>
